import React from 'react';
import { ExternalLink } from '../../../components';
import { FormattedMessage } from '../../../util/reactIntl';
import css from '../TermsOfServicePage.module.css';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

function ConsumerTermsGreek() {
  const history = useHistory();
  return (
    <div className="terms-page">
      <h1>ΟΡΟΙ ΧΡΗΣΗΣ ΓΙΑ ΚΑΤΑΝΑΛΩΤΕΣ (CONSUMERS)</h1>

      <h2>ΠΛΗΡΟΦΟΡΙΕΣ ΕΓΓΡΑΦΟΥ</h2>
      <p>
        Εφαρμόζεται σε: Καταναλωτές (Χρήστες) που αναζητούν ή κλείνουν υπηρεσίες μέσω της Πλατφόρμας
        <br />
        Τελευταία τροποποίηση: 5/12/2025
        <br />
        Σχετικά έγγραφα:{' '}
        <span
          className={css.termsLink}
          role="button"
          onClick={() => history.push('/terms-of-service?tab=professional')}
        >
          Όροι Χρήσης για Επαγγελματίες
        </span>{' '}
        | <ExternalLink href="/privacy-policy">Πολιτική Απορρήτου</ExternalLink>
      </p>

      <h2>Προοίμιο</h2>
      <p>
        Οι παρόντες Όροι Χρήσης εφαρμόζονται αποκλειστικά σε Καταναλωτές (αναφερόμενους και ως
        «Χρήστες») που εγγράφονται και χρησιμοποιούν τον ιστότοπο www.vivianlab.gr,
        www.vivianlab.com και www.vivianlab.health, καθώς και τις σχετικές εφαρμογές για κινητά
        (συλλογικά, η «Πλατφόρμα»), με σκοπό την αναζήτηση, κράτηση ή λήψη υπηρεσιών.
      </p>
      <p>
        Η Πλατφόρμα ανήκει και λειτουργεί από την εταιρεία με την επωνυμία «VIVIANLAB LTD» και τον
        διακριτικό τίτλο «Vivian Lab», με έδρα 1612 SOFIA BUL. TSAR BORIS III № 81 ET.1, AP.1, VAT
        BG207933919, ηλεκτρονική επικοινωνία info@vivianlab.com (η «Εταιρεία»).
      </p>
      <p>
        Όλο το περιεχόμενο, τα εμπορικά σήματα και τα ονόματα χώρου (domains) (συμπεριλαμβανομένων
        των www.vivianlab.gr, www.vivianlab.com και www.vivianlab.health) αποτελούν αποκλειστική
        ιδιοκτησία της Εταιρείας και προστατεύονται από το δίκαιο περί πνευματικής ιδιοκτησίας,
        εμπορικών σημάτων και κάθε άλλη εφαρμοστέα νομοθεσία.
      </p>
      <p>
        Η Εταιρεία δεσμεύεται να διασφαλίζει ότι η Πλατφόρμα είναι προσβάσιμη σε όλους τους χρήστες,
        συμπεριλαμβανομένων των ατόμων με αναπηρία, σύμφωνα με τον Ευρωπαϊκό Νόμο για την
        Προσβασιμότητα (Οδηγία (ΕΕ) 2019/882) και τα σχετικά τεχνικά πρότυπα.
      </p>
      <p>
        Αποποίηση Ιατρικής Ευθύνης & ΤΝ: Η Πλατφόρμα παρέχει εργαλεία που ενδέχεται να προσφέρουν
        πληροφορίες ευεξίας, παρακολούθηση συμπτωμάτων ή καθοδήγηση με χρήση Τεχνητής Νοημοσύνης. Τα
        εργαλεία αυτά δεν αποτελούν ιατρική συμβουλή, διάγνωση ή θεραπεία και δεν υποκαθιστούν τη
        συμβουλή επαγγελματία υγείας. Η Πλατφόρμα δεν προορίζεται για ιατρικά επείγοντα ή επείγουσες
        καταστάσεις υγείας. Σε περίπτωση σοβαρών συμπτωμάτων, πρέπει να επικοινωνήσετε άμεσα με
        γιατρό ή τις υπηρεσίες έκτακτης ανάγκης.
      </p>
      <p>
        Παγκόσμια Δήλωση Αποποίησης Κανονιστικής Ευθύνης (ΕΕ & ΗΠΑ): Η Πλατφόρμα και οι υπηρεσίες της
        προορίζονται αποκλειστικά για σκοπούς γενικής ευεξίας και ενημέρωσης και δεν ταξινομούνται ως
        ιατροτεχνολογικά προϊόντα βάσει του Κανονισμού (ΕΕ) 2017/745, ούτε ρυθμίζονται από την Υπηρεσία
        Τροφίμων και Φαρμάκων των ΗΠΑ (FDA). Η Πλατφόρμα δεν παρέχει ιατρικές συμβουλές, διάγνωση ή
        θεραπεία σε καμία δικαιοδοσία.
      </p>
      <p>
        Διαφάνεια Συστήματος AI & Ανθρώπινη Εποπτεία: Οι λειτουργίες Τεχνητής Νοημοσύνης (AI) που είναι
        διαθέσιμες στην Πλατφόρμα λειτουργούν χωρίς ανθρώπινη επίβλεψη σε πραγματικό χρόνο και δεν
        περιλαμβάνουν ανθρώπινη αναθεώρηση των επιμέρους αποτελεσμάτων. Το σύστημα παράγει απαντήσεις
        βάσει προτύπων σε δεδομένα και ενδέχεται να παράγει αποτελέσματα που είναι ανακριβή, ελλιπή ή
        παραπλανητικά. Οι χρήστες οφείλουν να επαληθεύουν ανεξάρτητα όλες τις πληροφορίες πριν προβούν σε
        οποιαδήποτε ενέργεια βάσει αυτών.
      </p>

      <h2>1. ΟΡΙΣΜΟΙ</h2>
      <p>Για τους σκοπούς των παρόντων Όρων Χρήσης:</p>
      <ul>
        <li>
          <strong>«Καταναλωτής» ή «Χρήστης»:</strong> Κάθε άτομο που χρησιμοποιεί την Πλατφόρμα για
          να αναζητήσει, να κλείσει ή να λάβει υπηρεσίες ή ψηφιακό περιεχόμενο από Επαγγελματίες
          Χρήστες.
        </li>
        <li>
          <strong>«Επαγγελματίας Χρήστης» ή «Πάροχος»:</strong> Κάθε φυσικό ή νομικό πρόσωπο που
          είναι εγγεγραμμένο στην Πλατφόρμα για να προσφέρει επαγγελματικές υπηρεσίες
          (συμπεριλαμβανομένων ειδικών υγείας, συμβούλων και επιχειρήσεων στον τομέα της υγείας και
          ευεξίας). Η Εταιρεία δεν επαληθεύει ούτε εγγυάται την επαγγελματική άδεια, επάρκεια ή
          κανονιστική συμμόρφωση των Επαγγελματιών Χρηστών, εκτός εάν αναφέρεται ρητά.
        </li>
        <li>
          <strong>«Πλατφόρμα» ή «Marketplace»:</strong> Το διαδικτυακό περιβάλλον που λειτουργεί υπό
          το εμπορικό σήμα VivianLab, προσβάσιμο μέσω ιστοσελίδας και εφαρμογών κινητών.
        </li>
        <li>
          <strong>«Εταιρεία»:</strong> Το νομικό πρόσωπο που κατέχει και λειτουργεί την Πλατφόρμα.
        </li>
        <li>
          <strong>«Υπηρεσίες»:</strong> Όλες οι διαμεσολαβητικές υπηρεσίες που παρέχονται από την
          Εταιρεία μέσω της Πλατφόρμας, συμπεριλαμβανομένης της προβολής επαγγελματικού προφίλ, του
          προγραμματισμού ραντεβού, των συνεδριών μέσω βίντεο (video consultations), του εκπαιδευτικού
          περιεχομένου και των λειτουργιών που υποστηρίζονται από Τεχνητή Νοημοσύνη (AI).
        </li>
        <li>
          <strong>«Εργαλεία ΤΝ»:</strong> Αυτοματοποιημένα ψηφιακά εργαλεία που διατίθενται μέσω της
          Πλατφόρμας και παράγουν προτάσεις σχετικές με την ευεξία, εκπαιδευτικό περιεχόμενο ή
          πληροφορίες σχετικά με συμπτώματα βάσει δεδομένων που παρέχονται από τον χρήστη. Τα Εργαλεία ΤΝ
          έχουν αποκλειστικά ενημερωτικό χαρακτήρα και δεν παρέχουν ιατρική διάγνωση ή κλινική λήψη
          αποφάσεων.
        </li>
        <li>
          <strong>«Σύστημα ΤΝ»:</strong> Κάθε σύστημα λογισμικού που αναπτύσσεται ή ενσωματώνεται από την
          Εταιρεία και παράγει αποτελέσματα όπως προβλέψεις, συστάσεις ή περιεχόμενο που επηρεάζει τις
          αποφάσεις των χρηστών, κατά την έννοια της Πράξης της ΕΕ για την Τεχνητή Νοημοσύνη (EU AI
          Act).
        </li>
        <li>
          <strong>«Συμφωνία»:</strong> Οι παρόντες Όροι Χρήσης μαζί με την{' '}
          <ExternalLink href="/privacy-policy">Πολιτική Απορρήτου</ExternalLink> .
        </li>
        <li>
          <strong>«Εργάσιμες Ημέρες»:</strong> Κάθε ημέρα πλην Σαββάτου, Κυριακής ή επίσημης αργίας
          στην Ελλάδα.
        </li>
        <li>
          <strong>«Συνεδρία» ή «Ραντεβού»:</strong> Προγραμματισμένη διαβούλευση ή παροχή υπηρεσίας
          μεταξύ Καταναλωτή και Επαγγελματία Χρήστη μέσω της Πλατφόρμας.
        </li>
        <li>
          <strong>«Συνδρομή»:</strong> Πληρωμένη πρόσβαση σε premium λειτουργίες και περιεχόμενο της
          Πλατφόρμας (μηνιαία ή ετήσια).
        </li>
      </ul>

      <h2>2. ΑΠΟΔΟΧΗ ΤΩΝ ΟΡΩΝ</h2>
      <p>
        Με την εγγραφή ή χρήση της Πλατφόρμας, ο Καταναλωτής αποδέχεται πλήρως και ανεπιφύλακτα ότι
        δεσμεύεται από:
      </p>
      <ol>
        <li>Τους παρόντες Όρους Χρήσης για Καταναλωτές</li>
        <li>
          Την <ExternalLink href="/privacy-policy">Πολιτική Απορρήτου</ExternalLink>
        </li>
        <li>
          Την <ExternalLink href="/cookie-policy">Πολιτική Cookies</ExternalLink>
        </li>
      </ol>
      <p>
        Με τη χρήση λειτουργιών ΤΝ στην Πλατφόρμα, αναγνωρίζετε ότι οι απαντήσεις μπορεί να παράγονται
        από αυτοματοποιημένα συστήματα και ενδέχεται να είναι ανακριβείς ή ελλιπείς. Συμφωνείτε να μην
        βασίζεστε στο περιεχόμενο της ΤΝ για λήψη ιατρικών αποφάσεων.
      </p>
      <p>
        Αναγνωρίζετε ότι τα αποτελέσματα της Τεχνητής Νοημοσύνης (AI) παράγονται αυτόματα χωρίς
        ανθρώπινη παρέμβαση και ενδέχεται να μην αντανακλούν ακριβείς, πλήρεις ή ενημερωμένες
        πληροφορίες. Αναλαμβάνετε την πλήρη ευθύνη για οποιεσδήποτε αποφάσεις ή ενέργειες λάβετε με βάση
        το περιεχόμενο που δημιουργείται από την Τεχνητή Νοημοσύνη.
      </p>
      <p>
        Εάν δεν αποδέχεστε τους όρους, δεν πρέπει να εγγραφείτε ή να χρησιμοποιήσετε την Πλατφόρμα.
      </p>

      <h2>3. ΠΡΟΣΤΑΣΙΑ ΔΕΔΟΜΕΝΩΝ</h2>
      <p>
        Η Εταιρεία ενεργεί ως Υπεύθυνος Επεξεργασίας για τα προσωπικά δεδομένα που παρέχετε
        απευθείας για σκοπούς όπως:
      </p>
      <ul>
        <li>Δημιουργία και διαχείριση λογαριασμού Καταναλωτή</li>
        <li>Επεξεργασία πληρωμών συνδρομών και ραντεβού</li>
        <li>Αποστολή ενημερωτικών δελτίων και προωθητικών μηνυμάτων (με τη συγκατάθεσή σας)</li>
        <li>Διαχείριση και ασφάλεια της Πλατφόρμας</li>
      </ul>
      <p>
        Όταν κλείνετε υπηρεσίες με Επαγγελματία Χρήστη, ο Επαγγελματίας ενεργεί ως Υπεύθυνος
        Επεξεργασίας για τα δεδομένα που σχετίζονται με τη συνεδρία. Η Εταιρεία μπορεί να
        επεξεργάζεται αυτά τα δεδομένα ως Εκτελών την Επεξεργασία.
      </p>
      <p>
        Η Πλατφόρμα επεξεργάζεται δεδομένα σχετικά με την εμμηνόπαυση, ορμονική υγεία, συμπτώματα
        και ευεξία, τα οποία ενδέχεται να αποτελούν ειδικές κατηγορίες δεδομένων κατά το άρθρο 9
        GDPR. Η επεξεργασία γίνεται μόνο με τη ρητή συγκατάθεσή σας, αποκλειστικά για την παροχή των
        υπηρεσιών της Πλατφόρμας, των εργαλείων ΤΝ και της εξατομικευμένης καθοδήγησης ευεξίας.
      </p>
      <p>
        Τα αποτελέσματα ΤΝ μπορεί να βασίζονται σε συγκεντρωτικά ή ψευδωνυμοποιημένα δεδομένα. Η
        Εταιρεία δεν χρησιμοποιεί τα δεδομένα υγείας σας για αυτοματοποιημένη λήψη αποφάσεων που
        παράγουν έννομα αποτελέσματα.
      </p>
      <p>
        Όλες οι πληροφορίες σχετικά με τους σκοπούς επεξεργασίας, τις νομικές βάσεις, τους χρόνους
        διατήρησης, τους αποδέκτες και τα δικαιώματά σας περιγράφονται στην{' '}
        <ExternalLink href="/privacy-policy">Πολιτική Απορρήτου</ExternalLink> .
      </p>

      <h3>Διαφάνεια Επεξεργασίας ΤΝ</h3>
      <p>
        Η Εταιρεία χρησιμοποιεί συστήματα Τεχνητής Νοημοσύνης (AI) για την επεξεργασία δεδομένων που
        παρέχονται από τον χρήστη (συμπεριλαμβανομένων δεδομένων που σχετίζονται με την υγεία, όπου
        ισχύει) για τη δημιουργία πληροφοριών και συστάσεων ευεξίας. Αυτή η επεξεργασία δεν περιλαμβάνει
        κατάρτιση προφίλ (profiling) που παράγει έννομα ή παρομοίως σημαντικά αποτελέσματα βάσει του Άρθρου
        22 του Γενικού Κανονισμού Προστασίας Δεδομένων (GDPR). Τα αποτελέσματα της ΤΝ δεν
        χρησιμοποιούνται για τη λήψη αποφάσεων που επηρεάζουν τα νόμιμα δικαιώματά σας, την πρόσβαση σε
        υπηρεσίες ή την οικονομική σας κατάσταση.
      </p>
      <h3>Διεθνής Συμμόρφωση για την Προστασία Δεδομένων</h3>
      <p>
        Στις περιπτώσεις όπου η πρόσβαση στην Πλατφόρμα γίνεται από χρήστες εκτός του Ευρωπαϊκού Οικονομικού
        Χώρου, συμπεριλαμβανομένων των Ηνωμένων Πολιτειών, η Εταιρεία εφαρμόζει πρότυπα προστασίας
        δεδομένων εναρμονισμένα με την ισχύουσα νομοθεσία, συμπεριλαμβανομένου του GDPR και των σχετικών
        πολιτειακών νόμων περί ιδιωτικότητας των ΗΠΑ, όπου αυτοί έχουν εφαρμογή.
      </p>

      <h3>
        <FormattedMessage id="ProfileImagesSection.titleWithNumber" values={{ number: '3.1' }} />
      </h3>
      <ul>
        <li>
          <FormattedMessage id="ProfileImagesSection.cameraAccess" />
        </li>
        <li>
          <FormattedMessage id="ProfileImagesSection.usage" />
        </li>
        <li>
          <FormattedMessage id="ProfileImagesSection.storage" />
        </li>
      </ul>

      <h2>4. ΔΙΑΔΙΚΤΥΑΚΕΣ ΥΠΗΡΕΣΙΕΣ ΠΟΥ ΠΑΡΕΧΕΙ Η ΠΛΑΤΦΟΡΜΑ</h2>
      <p>
        Η Πλατφόρμα αποτελεί μία διαμεσολαβητική αγορά που εξειδικεύεται σε υπηρεσίες υγείας,
        ευεξίας και συναφείς συμβουλευτικές υπηρεσίες. Η Πλατφόρμα δεν παρέχει η ίδια ιατρικές,
        υγειονομικές ή επαγγελματικές υπηρεσίες. Παρέχει μόνο τα τεχνικά μέσα ώστε οι Καταναλωτές να
        συνδέονται με Επαγγελματίες Χρήστες και να λαμβάνουν υπηρεσίες από αυτούς.
      </p>
      <p>
        Μη Ιατρική Συσκευή: Η Πλατφόρμα, συμπεριλαμβανομένων των εργαλείων Τεχνητής Νοημοσύνης (ΤΝ),
        δεν ταξινομείται ως ιατρική συσκευή σύμφωνα με τον Ευρωπαϊκό Κανονισμό για τις Ιατρικές
        Συσκευές (ΕΕ) 2017/745 και δεν πρέπει να χρησιμοποιείται για διάγνωση, θεραπεία ή κλινική
        αξιολόγηση κινδύνου.
      </p>
      <p>Οι υπηρεσίες που διατίθενται μέσω της Πλατφόρμας περιλαμβάνουν:</p>
      <h3>4.1 Δωρεάν Υπηρεσίες</h3>
      <ul>
        <li>
          Περιήγηση σε επαγγελματικά προφίλ (στοιχεία επικοινωνίας, προσόντα, ειδικότητες,
          παρεχόμενες υπηρεσίες, τιμές, ωράριο λειτουργίας)
        </li>
        <li>Πρόσβαση σε εκπαιδευτικό περιεχόμενο (άρθρα, βίντεο, συνταγές)</li>
        <li>Χρήση εργαλείων ΤΝ (παρακολούθηση συμπτωμάτων, εξατομικευμένη καθοδήγηση).</li>
        <li>
          Τα εργαλεία ΤΝ ενδέχεται να παράγουν προτάσεις ευεξίας βάσει των δεδομένων που εισάγει ο
          χρήστης. Οι προτάσεις αυτές είναι γενικού και μη κλινικού χαρακτήρα, ενδέχεται να
          περιέχουν ανακρίβειες, και δεν υποκαθιστούν τη συμβουλή εξειδικευμένου επαγγελματία
          υγείας.
        </li>
        <li>Συμμετοχή σε δωρεάν ομαδικά webinars και γραμμές υποστήριξης</li>
      </ul>
      <p>
        Τα εργαλεία Τεχνητής Νοημοσύνης (AI) είναι μη ντετερμινιστικά συστήματα και ενδέχεται να
        παράγουν διαφορετικά αποτελέσματα για την ίδια εισαγωγή δεδομένων. Η Εταιρεία δεν εγγυάται τη
        συνέπεια, την ακρίβεια ή την αξιοπιστία του περιεχομένου που παράγεται από την ΤΝ. Τα
        αποτελέσματα που παράγονται από την ΤΝ ενδέχεται να ποικίλλουν και δεν πρέπει να ερμηνεύονται ως
        επαγγελματικές, ιατρικές ή ρυθμιζόμενες συμβουλές σε καμία δικαιοδοσία.
      </p>
      <h3>4.2 Συνδρομητικές Υπηρεσίες</h3>
      <p>
        Η πρόσβαση σε ορισμένες premium λειτουργίες και περιεχόμενο απαιτεί πληρωμένη συνδρομή.
      </p>
      <p>Κοστίζει 45€ για 1 χρόνο ή 4,99€ για 1 μήνα.</p>
      <p>Οι συνδρομές περιλαμβάνουν:</p>
      <ul>
        <li>Πρόσβαση σε αποκλειστικά άρθρα, βίντεο και συνταγές</li>
        <li>Συμμετοχή σε premium webinars και ομαδικές συνεδρίες</li>
        <li>Αναβαθμισμένα εργαλεία ΤΝ και εξατομικευμένο περιεχόμενο</li>
      </ul>
      <p>Όροι Συνδρομής</p>
      <ul>
        <li>
          Δωρεάν Δοκιμή: Η συνδρομή σας ξεκινά με μια δωρεάν δοκιμαστική περίοδο 14 ημερών. Με τη
          λήξη της δοκιμαστικής περιόδου, θα χρεωθείτε αυτόματα το πλήρες ποσό της συνδρομής, εκτός
          εάν ακυρώσετε τουλάχιστον 24 ώρες πριν από τη λήξη της δοκιμής.
        </li>
        <li>
          Αυτόματη Ανανέωση: Οι συνδρομές ανανεώνονται αυτόματα, εκτός εάν ακυρωθούν τουλάχιστον 24
          ώρες πριν από την ημερομηνία ανανέωσης.
        </li>
        <li>Πολιτική Επιστροφής Χρημάτων: Τα τέλη συνδρομής δεν επιστρέφονται.</li>
        <li>
          Ακύρωση: Μπορείτε να ακυρώσετε τη συνδρομή σας ανά πάσα στιγμή μέσω των ρυθμίσεων του
          λογαριασμού σας ή επικοινωνώντας με την εταιρεία.
        </li>
      </ul>
      <h3>4.3 Ατομικές Συνεδρίες</h3>
      <p>
        Οι Καταναλωτές μπορούν να κλείσουν ατομικές συνεδρίες με Επαγγελματίες Χρήστες. Οι συνεδρίες
        αυτές:
      </p>
      <ul>
        <li>Χρεώνονται ξεχωριστά από τη συνδρομή</li>
        <li>Τιμολογούνται από τον Επαγγελματία Χρήστη (όχι από την Εταιρεία)</li>
        <li>
          Πραγματοποιούνται μέσω βιντεοκλήσης (Google Meet ή του συστήματος της Πλατφόρμας) ή
          μέσω συνομιλίας (chat)
        </li>
      </ul>
      <p>
        Η Εταιρεία δεσμεύεται ότι η Πλατφόρμα και τα μέσα παροχής διαδικτυακών υπηρεσιών
        συμμορφώνονται με τους όρους της σύμβασης και είναι κατάλληλα για τους σκοπούς για τους
        οποίους χρησιμοποιούνται υπηρεσίες ψηφιακής διαμεσολάβησης, με την απαιτούμενη επαγγελματική
        επιμέλεια και δεξιότητα.
      </p>

      <h3>4.4 Περιορισμοί Συστήματος ΤΝ και Ευθύνη Χρήστη</h3>
      <p>
        Οι λειτουργίες Τεχνητής Νοημοσύνης (AI) που παρέχονται μέσω της Πλατφόρμας έχουν σχεδιαστεί
        αποκλειστικά για σκοπούς γενικής ευεξίας και ενημέρωσης. Δεν προορίζονται να αντικαταστήσουν την
        επαγγελματική ιατρική κρίση, διάγνωση ή θεραπεία.
      </p>
      <p>Οι χρήστες αναγνωρίζουν ότι:</p>
      <ul>
        <li>
          Τα αποτελέσματα της ΤΝ ενδέχεται να είναι ανακριβή, ελλιπή, μεροληπτικά ή παρωχημένα.
        </li>
        <li>
          Η ΤΝ δεν κατανοεί το ατομικό ιατρικό ιστορικό, εκτός εάν αυτό παρασχεθεί ρητά.
        </li>
        <li>
          Η ΤΝ δεν μπορεί να αξιολογήσει επείγοντα περιστατικά ή κρίσιμες καταστάσεις υγείας.
        </li>
      </ul>
      <p>
        Οι χρήστες παραμένουν αποκλειστικά υπεύθυνοι για την αξιολόγηση των αποτελεσμάτων της ΤΝ και
        οφείλουν να συμβουλεύονται εξειδικευμένους επαγγελματίες πριν λάβουν αποφάσεις που σχετίζονται με
        την υγεία τους.
      </p>

      <h2>5. ΥΠΟΧΡΕΩΣΕΙΣ ΚΑΤΑΝΑΛΩΤΗ</h2>
      <h3>5.1 Απαιτήσεις Εγγραφής και Λογαριασμού</h3>
      <p>Οι Καταναλωτές πρέπει να:</p>
      <ul>
        <li>
          Παρέχουν ακριβείς, πλήρεις και ενημερωμένες πληροφορίες κατά την εγγραφή,
          συμπεριλαμβανομένων:
          <ul>
            <li>Ονοματεπώνυμο</li>
            <li>Διεύθυνση email</li>
            <li>Στοιχεία επικοινωνίας</li>
            <li>Στοιχεία πληρωμής (για συνδρομές και ραντεβού)</li>
          </ul>
        </li>
        <li>Ενημερώνουν άμεσα το προφίλ τους σε περίπτωση αλλαγών</li>
      </ul>
      <p>
        Ο Καταναλωτής φέρει αποκλειστική ευθύνη για την παροχή αληθών και ακριβών πληροφοριών. Ο
        Καταναλωτής ευθύνεται για κάθε ζημία που μπορεί να υποστεί η Εταιρεία λόγω παραβίασης της
        υποχρέωσης αυτής.
      </p>
      <h3>5.2 Ασφάλεια Λογαριασμού</h3>
      <p>
        Οι Καταναλωτές είναι υπεύθυνοι για τη διατήρηση της εμπιστευτικότητας και ασφάλειας των
        διαπιστευτηρίων πρόσβασής τους, συμπεριλαμβανομένων κωδικών πρόσβασης και στοιχείων
        ταυτοποίησης.
      </p>
      <p>
        Οι Καταναλωτές πρέπει να επιλέγουν ισχυρούς, μοναδικούς κωδικούς και να λαμβάνουν εύλογα
        μέτρα προστασίας από μη εξουσιοδοτημένη πρόσβαση.
      </p>
      <p>
        Η Εταιρεία δεν ευθύνεται για απώλεια ή ζημία που προκύπτει από αδυναμία συμμόρφωσης του
        Καταναλωτή με τις υποχρεώσεις ασφάλειας.
      </p>
      <h3>5.3 Νόμιμη Χρήση</h3>
      <p>Οι Καταναλωτές πρέπει να:</p>
      <ul>
        <li>Χρησιμοποιούν την Πλατφόρμα νόμιμα και σύμφωνα με τους παρόντες Όρους Χρήσης</li>
        <li>Μην εμπλέκονται σε δόλιες ενέργειες ή κακή χρήση της Πλατφόρμας</li>
        <li>Σέβονται τα δικαιώματα των Επαγγελματιών Χρηστών και άλλων Καταναλωτών</li>
        <li>Ενεργούν με καλή πίστη και σεβασμό</li>
        <li>
          Οι Καταναλωτές δεν πρέπει να βασίζονται σε πληροφορίες που παράγονται από ΤΝ για ιατρικές
          αποφάσεις ή επείγουσες καταστάσεις. Πρέπει να χρησιμοποιούν την Πλατφόρμα υπεύθυνα και να
          συμβουλεύονται επαγγελματίες υγείας για ιατρική καθοδήγηση.
        </li>
      </ul>
      <p>
        Οι χρήστες δεν πρέπει να επιχειρούν να χειραγωγήσουν, να εκμεταλλευτούν ή να δοκιμάσουν το σύστημα
        ΤΝ με τρόπους που ενδέχεται να παράγουν επιβλαβή, παραπλανητικά ή μη ασφαλή αποτελέσματα.
      </p>

      <h2>6. ΟΡΟΙ ΚΡΑΤΗΣΗΣ ΚΑΙ ΠΛΗΡΩΜΩΝ</h2>
      <h3>6.1 Κράτηση Ραντεβού</h3>
      <p>Για να κλείσετε ατομική συνεδρία με Επαγγελματία Χρήστη:</p>
      <ol>
        <li>Περιηγηθείτε στα επαγγελματικά προφίλ</li>
        <li>Επιλέξτε Επαγγελματία Χρήστη και διαθέσιμη ώρα ραντεβού</li>
        <li>
          Παρέχετε τις απαραίτητες πληροφορίες (όνομα, στοιχεία επικοινωνίας, λόγο της συνεδρίας)
        </li>
        <li>Επιβεβαιώστε την κράτηση και τη μέθοδο πληρωμής</li>
      </ol>
      <p>
        Με την ολοκλήρωση της κράτησης, θα λάβετε email επιβεβαίωσης με τα στοιχεία του ραντεβού.
      </p>
      <h3>6.2 Επεξεργασία Πληρωμών</h3>
      <p>
        Οι πληρωμές διεκπεραιώνονται μέσω του Stripe, ενός τρίτου παρόχου πληρωμών. Με την
        καταχώριση των στοιχείων πληρωμής, αποδέχεστε τους Όρους και Προϋποθέσεις του Stripe.
      </p>
      <p>
        Η Εταιρεία δεν χειρίζεται άμεσα τις πληρωμές και δεν ευθύνεται για προβλήματα που προκύπτουν
        κατά την επεξεργασία πληρωμών. Σε περιπτώσεις διαφορών που σχετίζονται με υπηρεσίες
        Επαγγελματιών Χρηστών, η Εταιρεία ενεργεί μόνο ως διαμεσολαβητής και δεν ευθύνεται για την
        ποιότητα, καταλληλότητα ή το αποτέλεσμα των υπηρεσιών αυτών.
      </p>
      <p>Διαδικασία πληρωμής:</p>
      <ol>
        <li>Κατά την κράτηση ραντεβού, η πιστωτική σας κάρτα προ-εγκρίνεται (δεν χρεώνεται).</li>
        <li>Μετά τη συνεδρία, ο Επαγγελματίας Χρήστης επιβεβαιώνει την ολοκλήρωση.</li>
        <li>
          Μετά την επιβεβαίωση, η κάρτα σας χρεώνεται και τα χρήματα αποδίδονται στον Επαγγελματία
          Χρήστη.
        </li>
      </ol>
      <p>
        Εάν ο Επαγγελματίας Χρήστης δεν επιβεβαιώσει την πληρωμή εντός 7 ημερών, η προέγκριση θα
        ακυρωθεί και καμία χρέωση δεν θα πραγματοποιηθεί.
      </p>
      <h3>6.3 Τιμολόγηση</h3>
      <ul>
        <li>Τα τέλη συνδρομής καθορίζονται από την Εταιρεία και εμφανίζονται στην Πλατφόρμα</li>
        <li>
          Τα τέλη για ατομικές συνεδρίες καθορίζονται από τον Επαγγελματία Χρήστη και εμφανίζονται
          στο προφίλ του
        </li>
      </ul>
      <p>Η Εταιρεία δεν ελέγχει ούτε επαληθεύει τις τιμές που ορίζουν οι Επαγγελματίες Χρήστες.</p>
      <h3>6.4 Αποδείξεις και Τιμολόγια</h3>
      <ul>
        <li>Για συνδρομές: Η Εταιρεία εκδίδει απόδειξη ή τιμολόγιο</li>
        <li>
          Για ατομικές συνεδρίες: Ο Επαγγελματίας Χρήστης είναι υπεύθυνος για την έκδοση απόδειξης ή
          τιμολογίου
        </li>
      </ul>
      <p>
        Οι Επαγγελματίες Χρήστες υποχρεούνται να εκδίδουν τα νόμιμα φορολογικά παραστατικά για
        ατομικές συνεδρίες σύμφωνα με την εφαρμοστέα φορολογική και λογιστική νομοθεσία. Η Εταιρεία
        δεν φέρει ευθύνη για οποιεσδήποτε φορολογικές, αδειοδοτικές ή κανονιστικές υποχρεώσεις των
        Επαγγελματιών Χρηστών.
      </p>
      <h3>6.5 Κουπόνια και Κωδικοί Προσφοράς</h3>
      <p>
        Η Εταιρεία μπορεί να προσφέρει κουπόνια ή κωδικούς προσφοράς που μειώνουν ή καλύπτουν το
        κόστος συνεδριών ή συνδρομών. Τα κουπόνια και οι κωδικοί προσφοράς:
      </p>
      <ul>
        <li>
          Υπόκεινται σε συγκεκριμένους όρους και προϋποθέσεις (που εμφανίζονται κατά την έκδοση)
        </li>
        <li>Μπορεί να διαθέτουν ημερομηνία λήξης ή περιορισμούς χρήσης</li>
        <li>Δεν συνδυάζονται με άλλες προσφορές εκτός αν αναφέρεται ρητά</li>
        <li>Είναι μη μεταβιβάσιμα και δεν έχουν χρηματική αξία</li>
      </ul>

      <h2>7. ΔΙΚΑΙΩΜΑ ΥΠΑΝΑΧΩΡΗΣΗΣ</h2>
      <p>
        Για υπηρεσίες που ξεκινούν εντός της 14ήμερης περιόδου υπαναχώρησης (όπως ραντεβού ή
        πρόσβαση σε premium ψηφιακό περιεχόμενο), συμφωνείτε ότι με την έναρξη της υπηρεσίας
        παραιτείστε ρητά από το δικαίωμα υπαναχώρησης, όπως απαιτείται από την ευρωπαϊκή νομοθεσία
        προστασίας καταναλωτή.
      </p>
      <p>
        Ως Καταναλωτής, δικαιούστε να υπαναχωρήσετε από προγραμματισμένο ραντεβού ή συνδρομή εντός
        14 ημερολογιακών ημερών από την κράτηση ή την αγορά, εκτός εάν:
      </p>
      <ul>
        <li>Η υπηρεσία έχει ήδη εκτελεστεί· ή</li>
        <li>
          Έχετε δώσει ρητή συναίνεση για την έναρξη της υπηρεσίας εντός της περιόδου υπαναχώρησης
          και αναγνωρίζετε την απώλεια του δικαιώματος αυτού.
        </li>
      </ul>
      <h3>7.1 Υπαναχώρηση από Ραντεβού</h3>
      <p>Πολιτική ακύρωσης:</p>
      <ul>
        <li>Πάνω από 24 ώρες πριν το ραντεβού: Πλήρης επιστροφή χρημάτων</li>
        <li>
          Λιγότερο από 24 ώρες αλλά περισσότερες από 60 λεπτά: Ενδέχεται να επιβληθούν τέλη ακύρωσης
        </li>
        <li>Λιγότερο από 60 λεπτά πριν το ραντεβού: Δεν προβλέπεται επιστροφή χρημάτων</li>
      </ul>
      <p>
        Για ακύρωση ραντεβού, επικοινωνήστε με την Εταιρεία ή χρησιμοποιήστε τη λειτουργία ακύρωσης
        στον λογαριασμό σας.
      </p>
      <p>
        Οι επιστροφές ενδέχεται να χρειαστούν έως 14 εργάσιμες ημέρες για να χρεωθούν στον
        λογαριασμό σας λόγω απαιτήσεων επεξεργασίας.
      </p>
      <h3>7.2 Υπαναχώρηση από Ψηφιακό Περιεχόμενο</h3>
      <p>
        Για λήψη ψηφιακού περιεχομένου (όπως άρθρα, eBooks, βίντεο): Με τη λήψη, παραιτείστε ρητά
        από το δικαίωμα υπαναχώρησης.
      </p>
      <h3>7.3 Υπαναχώρηση από Συνδρομές</h3>
      <p>
        Τα τέλη συνδρομής γενικά δεν επιστρέφονται. Ωστόσο, μπορείτε να ακυρώσετε τη συνδρομή σας
        οποιαδήποτε στιγμή για να αποτρέψετε μελλοντικές ανανεώσεις.
      </p>
      <p>
        Τα αποτελέσματα της ΤΝ παράγονται χωρίς ανθρώπινη αναθεώρηση και ενδέχεται να μην
        ανταποκρίνονται στην πραγματικότητα ή στις ιδιαίτερες ατομικές περιστάσεις.
      </p>

      <h2>8. ΕΠΙΣΤΡΟΦΕΣ ΚΑΙ ΔΙΑΦΟΡΕΣ</h2>
      <h3>8.1 Επιστροφές λόγω Μη Παροχής Υπηρεσίας</h3>
      <p>
        Εάν πιστεύετε ότι ένας Επαγγελματίας Χρήστης δεν παρείχε ή δεν ολοκλήρωσε την υπηρεσία όπως
        αναμενόταν, μπορείτε να ζητήσετε επιστροφή χρημάτων επικοινωνώντας με την Εταιρεία στο
        info@vivianlab.com.
      </p>
      <p>
        Η Εταιρεία θα διενεργήσει έρευνα και μπορεί να εγκρίνει την επιστροφή χρημάτων εάν κρίνει,
        βάσει τεκμηριωμένων στοιχείων και αφού δώσει στον Επαγγελματία Χρήστη την ευκαιρία να
        απαντήσει, ότι η υπηρεσία δεν εκπληρώθηκε.
      </p>
      <p>
        Κατόπιν αιτήματος, η Εταιρεία θα σας παρέχει συνοπτική εξήγηση των λόγων για την απόφαση
        επιστροφής, εκτός εάν αυτό απαγορεύεται από το νόμο ή είναι απαραίτητο για την αποτροπή
        απάτης.
      </p>
      <h3>8.2 Τεχνικές Αστοχίες</h3>
      <p>
        Εάν τεχνικό πρόβλημα εμποδίσει εσάς ή τον Επαγγελματία Χρήστη να συμμετάσχετε σε
        προγραμματισμένη συνεδρία (π.χ. δυσλειτουργία της πλατφόρμας, αποτυχία σύνδεσης), η Εταιρεία
        μπορεί, κατά την κρίση της, να ακυρώσει τη συνεδρία. Σε αυτές τις περιπτώσεις:
      </p>
      <ul>
        <li>Δεν θα πραγματοποιηθεί χρέωση</li>
        <li>Η συνεδρία μπορεί να επαναπρογραμματιστεί χωρίς επιπλέον κόστος</li>
      </ul>
      <p>
        Τεχνικές αστοχίες που προκύπτουν από τη συσκευή, την σύνδεση στο διαδίκτυο ή τη ρύθμιση
        λογισμικού του χρήστη δεν αποτελούν λόγο αυτόματης επιστροφής χρημάτων. Αυτό παραμένει στη
        διακριτική ευχέρεια της Εταιρείας.
      </p>

      <h2>9. ΑΠΑΓΟΡΕΥΜΕΝΗ ΣΥΜΠΕΡΙΦΟΡΑ</h2>
      <p>Οι Καταναλωτές δεν πρέπει να:</p>
      <ul>
        <li>Δημιουργούν ψεύτικους λογαριασμούς ή να εμπλέκονται σε δόλιες δραστηριότητες</li>
        <li>Κάνουν κακή χρήση προσωπικών δεδομένων Επαγγελματιών Χρηστών ή άλλων Καταναλωτών</li>
        <li>Χρησιμοποιούν προσβλητική, απειλητική ή διακριτική γλώσσα</li>
        <li>
          Παρενοχλούν Επαγγελματίες Χρήστες ή άλλους Καταναλωτές (παρενόχληση περιλαμβάνει λεκτικές
          ή γραπτές εκφράσεις που αποσκοπούν σε ψυχική ή σωματική βλάβη)
        </li>
        <li>Ανεβάζουν κακόβουλο λογισμικό, ιούς ή επιβλαβές υλικό</li>
        <li>Αντιγράφουν, διανέμουν ή αναπαράγουν περιεχόμενο της Πλατφόρμας χωρίς έγγραφη άδεια</li>
        <li>
          Χρησιμοποιούν τα εμπορικά σήματα, το branding ή την ταυτότητα της Εταιρείας χωρίς
          συναίνεση
        </li>
        <li>
          Κάνουν κακή χρήση των λειτουργιών ΤΝ, να εισάγουν ψευδή ή παραπλανητικά δεδομένα
          συμπτωμάτων ή να προσπαθούν να παράγουν ιατρικές διαγνώσεις μέσω της Πλατφόρμας
        </li>
      </ul>
      <p>
        Οι βασικές αξίες που διέπουν την Πλατφόρμα είναι ο σεβασμός και η εκτίμηση. Απαγορεύεται
        αυστηρά κάθε είδους διάκριση βάσει φύλου, ταυτότητας φύλου, εθνικότητας, θρησκείας,
        αναπηρίας, σεξουαλικού προσανατολισμού ή ηλικίας.
      </p>
      <p>Εάν οι κανόνες αυτοί δεν τηρηθούν, η Εταιρεία μπορεί:</p>
      <ul>
        <li>Να απενεργοποιήσει άμεσα τον λογαριασμό σας</li>
        <li>Να καταγγείλει τη Συμφωνία</li>
        <li>Να επικοινωνήσει με τις αρμόδιες αρχές</li>
        <li>Να επιδιώξει αποζημιώσεις και άλλα νόμιμα μέσα</li>
      </ul>

      <h2>10. ΔΙΚΑΙΩΜΑΤΑ ΠΝΕΥΜΑΤΙΚΗΣ ΙΔΙΟΚΤΗΣΙΑΣ</h2>
      <h3>10.1 Δικαιώματα της Εταιρείας</h3>
      <p>
        Όλο το περιεχόμενο, ο σχεδιασμός, τα εμπορικά σήματα, τα λογότυπα και το λογισμικό της
        Πλατφόρμας αποτελούν αποκλειστική ιδιοκτησία της Εταιρείας και προστατεύονται από το δίκαιο
        περί πνευματικής ιδιοκτησίας, εμπορικών σημάτων και άλλων συναφών δικαιωμάτων.
      </p>
      <p>
        Το περιεχόμενο που δημιουργείται από ΤΝ μπορεί να περιλαμβάνει αυτοματοποιημένο κείμενο. Το
        περιεχόμενο αυτό ανήκει ή έχει αδειοδοτηθεί στην Εταιρεία και παρέχεται αποκλειστικά για
        προσωπική, ενημερωτική χρήση.
      </p>
      <p>Απαγορεύεται να:</p>
      <ul>
        <li>
          Αντιγράφετε, αναπαράγετε, διανέμετε ή προβάλλετε περιεχόμενο της Πλατφόρμας χωρίς
          προηγούμενη γραπτή άδεια
        </li>
        <li>
          Χρησιμοποιείτε τα εμπορικά σήματα ή το branding της Εταιρείας για την προώθηση προϊόντων ή
          υπηρεσιών τρίτων
        </li>
        <li>
          Προβαίνετε σε reverse engineering, αποσυναρμολόγηση ή παρέμβαση στο λογισμικό ή τα
          συστήματα της Πλατφόρμας
        </li>
      </ul>
      <p>
        Προστασία εμπορικού σήματος: Το «VivianLab» αποτελεί καταχωρημένο εμπορικό σήμα
        προστατευόμενο σύμφωνα με το Άρθρο 6α της Σύμβασης των Παρισίων και την Οδηγία (ΕΕ)
        2015/2436.
      </p>
      <h3>10.2 Περιεχόμενο Χρήστη</h3>
      <p>
        Με την ανάρτηση περιεχομένου στο προφίλ σας ή στην Πλατφόρμα (περιλαμβανομένων φωτογραφιών,
        αξιολογήσεων, σχολίων), εσείς:
      </p>
      <ul>
        <li>Διατηρείτε την κυριότητα του περιεχομένου</li>
        <li>
          Παρέχετε στην Εταιρεία μη αποκλειστική, παγκόσμια, χωρίς δικαιώματα χρήσης άδεια για
          χρήση, προβολή και διανομή του περιεχομένου για την παροχή των Υπηρεσιών
        </li>
        <li>
          Εγγυάστε ότι διαθέτετε όλα τα αναγκαία δικαιώματα και ότι το περιεχόμενο δεν παραβιάζει
          δικαιώματα τρίτων
        </li>
      </ul>

      <h2>11. ΠΕΡΙΟΡΙΣΜΟΣ ΕΥΘΥΝΗΣ</h2>
      <h3>11.1 Περιορισμός Ευθύνης της Εταιρείας</h3>
      <p>
        Η Πλατφόρμα παρέχεται αποκλειστικά για ενημερωτικούς και διαμεσολαβητικούς σκοπούς. Δεν
        παρέχει ιατρικές, υγειονομικές ή επαγγελματικές συμβουλές ή υπηρεσίες.
      </p>
      <p>Στο μέγιστο βαθμό που επιτρέπεται από τον νόμο:</p>
      <p>Η Εταιρεία δεν ευθύνεται για:</p>
      <ul>
        <li>
          Το περιεχόμενο, την ποιότητα ή το αποτέλεσμα υπηρεσιών που παρέχονται από Επαγγελματίες
          Χρήστες
        </li>
        <li>Ακυρώσεις, μη εμφανίσεις ή μη ολοκληρωμένες συνεδρίες</li>
        <li>
          Οποιαδήποτε ζημία, απώλεια ή τραυματισμό προκύπτει από υπηρεσίες ή αλληλεπιδράσεις με
          Επαγγελματίες Χρήστες
        </li>
        <li>Απώλεια εσόδων, κερδών, συμβάσεων ή ειδικές, έμμεσες ή επακόλουθες ζημίες</li>
      </ul>
      <p>
        Η Πλατφόρμα παρέχεται «ως έχει» χωρίς καμία εγγύηση, ρητή ή σιωπηρή, συμπεριλαμβανομένων
        ενδεικτικά των εγγυήσεων εμπορευσιμότητας, καταλληλότητας ή απρόσκοπτης λειτουργίας.
      </p>
      <p>
        Ωστόσο, ο παρών περιορισμός ευθύνης δεν αποκλείει ή περιορίζει την ευθύνη της Εταιρείας για:
      </p>
      <ul>
        <li>Θάνατο ή σωματική βλάβη που προκύπτει από αμέλεια ή δόλο της Εταιρείας</li>
        <li>Οποιαδήποτε υποχρεωτική ευθύνη που δεν μπορεί να αποκλειστεί από τον νόμο</li>
      </ul>
      <h3>11.2 Αποποίηση Ευθύνης για την Πλατφόρμα & τα Εργαλεία ΤΝ</h3>
      <p>
        Η Πλατφόρμα, συμπεριλαμβανομένων των εργαλείων ΤΝ, των πληροφοριών ευεξίας, των προτάσεων
        συμπτωμάτων, του εκπαιδευτικού περιεχομένου και των ψηφιακών λειτουργιών, παρέχεται
        αποκλειστικά για γενικούς ενημερωτικούς και σκοπούς ευεξίας.
      </p>
      <p>
        Τα αποτελέσματα ΤΝ μπορεί να είναι ανακριβή, ελλιπή, παρωχημένα ή ασυνεπή και δεν πρέπει να
        χρησιμοποιούνται για ιατρικές ή κλινικές αποφάσεις.
      </p>
      <p>
        Τα εργαλεία ΤΝ δεν διαγιγνώσκουν, δεν θεραπεύουν, δεν προλαμβάνουν και δεν παρακολουθούν
        οποιαδήποτε ιατρική κατάσταση, συμπεριλαμβανομένων συμπτωμάτων σχετικών με την εμμηνόπαυση.
      </p>
      <p>Οι Καταναλωτές πρέπει να συμβουλεύονται αδειοδοτημένους επαγγελματίες υγείας.</p>
      <p>
        Τα συστήματα ΤΝ ενδέχεται να παρουσιάζουν εγγενείς περιορισμούς, συμπεριλαμβανομένων
        περιπτώσεων μεροληψίας, «παραισθήσεων» (hallucinations) ή απρόβλεπτων αποτελεσμάτων. Η Εταιρεία
        δεν εγγυάται ότι τα αποτελέσματα της ΤΝ είναι απαλλαγμένα από σφάλματα ή εναρμονισμένα με τα
        τρέχοντα ιατρικά πρότυπα. Οι λειτουργίες ΤΝ δεν προορίζονται για τη διάγνωση, τη θεραπεία, την ίαση
        ή την πρόληψη οποιασδήποτε νόσου σύμφωνα με την ισχύουσα νομοθεσία των ΗΠΑ.
      </p>
      <h3>11.3 Μη Ευθύνη για Περιεχόμενο ΤΝ ή Καθοδήγηση Ευεξίας</h3>
      <p>Η Εταιρεία, στο μέγιστο βαθμό που επιτρέπεται από τον νόμο, δεν ευθύνεται για:</p>
      <ul>
        <li>
          Τυχόν εξάρτηση του Καταναλωτή από περιεχόμενο ΤΝ, προτάσεις ευεξίας ή ερμηνείες
          συμπτωμάτων
        </li>
        <li>Αποφάσεις που λαμβάνονται βάσει αποτελεσμάτων ΤΝ ή εκπαιδευτικού περιεχομένου</li>
        <li>Σωματικές, ψυχολογικές ή συναισθηματικές συνέπειες από τη χρήση εργαλείων ΤΝ</li>
      </ul>
      <p>
        Ο Καταναλωτής παραμένει αποκλειστικά υπεύθυνος για την αξιολόγηση και επιβεβαίωση
        οποιασδήποτε πληροφορίας πριν προβεί σε ενέργειες. Η Εταιρεία δεν φέρει ευθύνη για τυχόν
        ζημίες που προκύπτουν από τους εγγενείς περιορισμούς των συστημάτων ΤΝ, συμπεριλαμβανομένων
        ενδεικτικά σφαλμάτων, παραλείψεων, μεροληψίας ή μη διαθεσιμότητας του συστήματος. Ο παρών
        περιορισμός ευθύνης ισχύει στον μέγιστο βαθμό που επιτρέπεται από την ισχύουσα νομοθεσία σε όλες
        τις δικαιοδοσίες όπου η Πλατφόρμα είναι προσβάσιμη, συμπεριλαμβανομένων των Ηνωμένων Πολιτειών.
      </p>
      <h3>11.4 Μη Ευθύνη για Υπηρεσίες Επαγγελματιών Χρηστών</h3>
      <p>
        Οι Επαγγελματίες Χρήστες λειτουργούν ως ανεξάρτητοι συνεργάτες και όχι ως υπάλληλοι,
        πράκτορες ή εκπρόσωποι της Εταιρείας.
      </p>
      <p>Η Εταιρεία δεν εγγυάται, δεν ελέγχει, δεν επιβλέπει και δεν επαληθεύει:</p>
      <ul>
        <li>Την ακρίβεια ή πληρότητα των πληροφοριών Επαγγελματιών Χρηστών</li>
        <li>Τα προσόντα, την άδεια άσκησης, τις πιστοποιήσεις ή την επάρκειά τους</li>
        <li>Την ποιότητα, το αποτέλεσμα ή την ολοκλήρωση των υπηρεσιών που παρέχουν</li>
      </ul>
      <p>
        Η Εταιρεία δεν ευθύνεται για ακυρώσεις, μη εμφανίσεις, δυσαρέσκεια ή συνέπειες που
        προκύπτουν από συμβουλές Επαγγελματιών Χρηστών.
      </p>
      <h3>11.5 Τεχνικά Ζητήματα</h3>
      <p>Η Εταιρεία δεν ευθύνεται για:</p>
      <ul>
        <li>Διακοπές υπηρεσίας</li>
        <li>Καθυστερήσεις ή αποτυχίες λόγω προβλημάτων δικτύου ή συσκευής χρήστη</li>
        <li>Απώλεια δεδομένων</li>
        <li>Ασυμβατότητα με τον εξοπλισμό ή το λογισμικό του χρήστη</li>
        <li>Αποτυχίες συστημάτων τρίτων (hosting, βιντεοκλήσεις, πάροχοι πληρωμών)</li>
      </ul>
      <h3>11.6 Γενικός Περιορισμός Ευθύνης</h3>
      <p>Εκτός όπου απαγορεύεται από τον νόμο, η Εταιρεία δεν ευθύνεται για:</p>
      <ul>
        <li>Απώλεια κερδών ή εσόδων</li>
        <li>Συναισθηματική βλάβη</li>
        <li>Απώλεια δεδομένων ή φήμης</li>
        <li>Έμμεσες, παρεπόμενες, τιμωρητικές ή επακόλουθες ζημίες</li>
        <li>Οποιαδήποτε ζημία που προκύπτει από κακή χρήση της Πλατφόρμας ή παραβίαση των Όρων</li>
      </ul>
      <h3>11.7 Ευθύνη Επαγγελματιών Χρηστών</h3>
      <p>
        Οι Επαγγελματίες Χρήστες είναι ανεξάρτητοι συνεργάτες και όχι υπάλληλοι ή εκπρόσωποι της
        Εταιρείας. Είναι αποκλειστικά υπεύθυνοι για:
      </p>
      <ul>
        <li>Το περιεχόμενο, την ποιότητα και την παροχή των υπηρεσιών τους</li>
        <li>
          Την επαγγελματική τους άδεια, την ασφάλιση και τη συμμόρφωση με την ισχύουσα νομοθεσία
        </li>
      </ul>
      <p>
        Η Εταιρεία δεν εγγυάται, δεν επικυρώνει και δεν επιβεβαιώνει τις υπηρεσίες ή ικανότητές
        τους.
      </p>

      <h2>12. ΑΝΩΤΕΡΑ ΒΙΑ (FORCE MAJEURE)</h2>
      <p>
        Η Εταιρεία δεν ευθύνεται για αδυναμία εκπλήρωσης υποχρεώσεων όταν αυτή οφείλεται σε γεγονότα
        πέρα από τον εύλογο έλεγχό της, συμπεριλαμβανομένων:
      </p>
      <ul>
        <li>Φυσικών καταστροφών</li>
        <li>Πολέμου, τρομοκρατίας, πολιτικών αναταραχών</li>
        <li>Απεργιών ή ελλείψεων προσωπικού</li>
        <li>Διακοπών σε δίκτυα επικοινωνίας</li>
        <li>Αδυναμίας λειτουργίας παρόχων πληρωμών</li>
        <li>Κυβερνητικών ενεργειών ή νομικών περιορισμών</li>
      </ul>
      <p>Διαταραχές σε υπηρεσίες ΤΝ ή API τρίτων θεωρούνται επίσης γεγονότα ανωτέρας βίας.</p>
      <p>
        Η Εταιρεία θα ενημερώνει τους επηρεαζόμενους Καταναλωτές εντός 15 ημερών και θα παρέχει
        εκτίμηση διάρκειας.
      </p>

      <h2>13. ΚΑΤΑΓΓΕΛΙΑ ΚΑΙ ΑΝΑΣΤΟΛΗ</h2>
      <h3>13.1 Καταγγελία από την Εταιρεία</h3>
      <p>
        Η Εταιρεία μπορεί να αναστείλει ή να τερματίσει άμεσα την πρόσβαση ενός Καταναλωτή στην
        Πλατφόρμα, χωρίς προηγούμενη ειδοποίηση, εάν:
      </p>
      <ul>
        <li>Παραβιάσει τους παρόντες Όρους Χρήσης</li>
        <li>Εμπλακεί σε παράνομη, δόλια ή επιβλαβή δραστηριότητα</li>
        <li>Η Εταιρεία λάβει δικαστική απόφαση ή κυβερνητική εντολή</li>
        <li>Η συνέχιση της υπηρεσίας δημιουργεί νομικό ή φήμης κίνδυνο</li>
      </ul>
      <p>
        Η Εταιρεία ενδέχεται επίσης να αναστείλει ή να περιορίσει τη λειτουργικότητα της ΤΝ, όπου αυτό
        απαιτείται, για τη συμμόρφωση με κανονιστικές υποχρεώσεις, τη λήψη μέτρων μείωσης κινδύνου ή για
        λόγους ασφαλείας βάσει της Πράξης της ΕΕ για την Τεχνητή Νοημοσύνη (EU AI Act).
      </p>
      <p>Γραπτή ειδοποίηση θα δοθεί μετά την ενέργεια.</p>
      <p>
        Η Εταιρεία μπορεί επίσης να αναστείλει ή να περιορίσει πρόσβαση σε εργαλεία ΤΝ για λόγους
        ασφάλειας, ακρίβειας ή συμμόρφωσης με τον EU AI Act.
      </p>
      <h3>13.2 Καταγγελία από τον Καταναλωτή</h3>
      <p>Ο Καταναλωτής μπορεί να καταγγείλει τη Συμφωνία οποτεδήποτε με:</p>
      <ul>
        <li>Κλείσιμο λογαριασμού μέσω των ρυθμίσεων· ή</li>
        <li>Αποστολή γραπτής ειδοποίησης στην Εταιρεία</li>
      </ul>
      <p>
        Μετά την καταγγελία, η Εταιρεία διαγράφει ή διατηρεί δεδομένα σύμφωνα με την{' '}
        <ExternalLink href="/privacy-policy">Πολιτική Απορρήτου</ExternalLink> και τη νομοθεσία.
      </p>
      <h3>13.3 Συνέπειες Καταγγελίας</h3>
      <p>Με την καταγγελία:</p>
      <ul>
        <li>Η πρόσβασή σας στην Πλατφόρμα τερματίζεται</li>
        <li>Ενεργές συνδρομές ακυρώνονται (χωρίς επιστροφή για μη χρησιμοποιημένο διάστημα)</li>
        <li>
          Τα δεδομένα σας θα υποβληθούν σε επεξεργασία σύμφωνα με την{' '}
          <ExternalLink href="/privacy-policy">Πολιτική Απορρήτου</ExternalLink>{' '}
        </li>
        <li>Ρήτρες που διατηρούνται μετά τον τερματισμό παραμένουν σε ισχύ</li>
        <li>
          Δεδομένα που παράγονται από ΤΝ μπορεί να διατηρούνται σε ανωνυμοποιημένη μορφή για λόγους
          ασφάλειας, ελέγχου και βελτίωσης μοντέλου
        </li>
      </ul>

      <h2>14. ΤΡΟΠΟΠΟΙΗΣΗ ΟΡΩΝ</h2>
      <p>
        Η Εταιρεία μπορεί να τροποποιεί τους Όρους Χρήσης, την{' '}
        <ExternalLink href="/privacy-policy">Πολιτική Απορρήτου</ExternalLink> και τις συναφείς
        πολιτικές για νομικούς λόγους, λόγους ασφαλείας ή επιχειρησιακές ανάγκες.
      </p>
      <p>
        Εάν μια τροποποίηση επηρεάζει ουσιωδώς και αρνητικά τη χρήση της Πλατφόρμας, θα λάβετε
        σχετική ειδοποίηση και δικαιούστε να καταγγείλετε τη Συμφωνία εντός 30 ημερών.
      </p>
      <p>
        Η συνεχής χρήση της Πλατφόρμας μετά την ισχύ των αλλαγών συνιστά αποδοχή των τροποποιημένων
        όρων.
      </p>
      <p>
        Σημαντικές αλλαγές στα εργαλεία ΤΝ, στη λογική αυτοματοποιημένης λήψης αποφάσεων ή στην
        επεξεργασία δεδομένων ειδικών κατηγοριών θα γνωστοποιούνται εκ των προτέρων, όπως απαιτείται
        από τον EU AI Act και τον GDPR.
      </p>

      <h2>15. ΕΚΧΩΡΗΣΗ ΔΙΚΑΙΩΜΑΤΩΝ</h2>
      <ul>
        <li>
          Οι Καταναλωτές δεν μπορούν να εκχωρούν δικαιώματα ή υποχρεώσεις χωρίς προηγούμενη γραπτή
          συναίνεση της Εταιρείας.
        </li>
        <li>
          Η Εταιρεία μπορεί να εκχωρεί δικαιώματα ή υποχρεώσεις σε τρίτους (π.χ. συγχώνευση,
          εξαγορά, μεταβίβαση επιχείρησης).
        </li>
      </ul>

      <h2>16. ΔΙΚΑΙΟ ΚΑΙ ΔΙΚΑΙΟΔΟΣΙΑ</h2>
      <h3>16.1 Εφαρμοστέο Δίκαιο</h3>
      <p>
        Η Συμφωνία διέπεται από το ελληνικό δίκαιο, ακόμη και όταν η Πλατφόρμα προσπελαύνεται εκτός
        Ελλάδας. Ζητήματα διαφάνειας, μεροληψίας ή ασφάλειας ΤΝ ερμηνεύονται σύμφωνα με τον EU AI Act.
        Τίποτα στους παρόντες Όρους δεν περιορίζει τυχόν υποχρεωτικά δικαιώματα προστασίας των
        καταναλωτών που ενδέχεται να ισχύουν βάσει της νομοθεσίας της χώρας στην οποία διαμένει ο
        χρήστης.
      </p>
      <h3>16.2 Επίλυση Διαφορών</h3>
      <p>
        Οποιαδήποτε διαφορά υπάγεται αρχικά σε διαδικασία διαμεσολάβησης σύμφωνα με τον Κανονισμό
        Διαμεσολάβησης του Υπουργείου Δικαιοσύνης.
      </p>
      <p>
        Αν δεν επιτευχθεί λύση, η διαφορά υπάγεται αποκλειστικά σε διαιτησία ή στα Δικαστήρια
        Αθηνών.
      </p>
      <h3>16.3 Διαχωρισμός Όρων</h3>
      <p>Εάν κάποια διάταξη κριθεί άκυρη, οι υπόλοιπες παραμένουν σε πλήρη ισχύ.</p>

      <h2>17. ΟΛΟΚΛΗΡΗ Η ΣΥΜΦΩΝΙΑ</h2>
      <p>
        Οι παρόντες Όροι Χρήσης και η Πολιτική Απορρήτου αποτελούν την πλήρη συμφωνία μεταξύ του
        Καταναλωτή και της Εταιρείας και αντικαθιστούν κάθε προηγούμενη συμφωνία, συνεννόηση ή
        επικοινωνία (είτε γραπτή είτε προφορική) που σχετίζεται με το εν λόγω αντικείμενο.
      </p>
      <p>
        Κανένας άλλος όρος, προϋπόθεση ή δήλωση δεν θεωρείται δεσμευτική, εκτός εάν έχει συμφωνηθεί
        εγγράφως από την Εταιρεία.
      </p>

      <h2>18. ΣΤΟΙΧΕΙΑ ΕΠΙΚΟΙΝΩΝΙΑΣ</h2>
      <p>
        Για ερωτήσεις ή απορίες σχετικά με τους παρόντες Όρους Χρήσης, παρακαλούμε επικοινωνήστε με:
        <br />
        Εταιρεία: VIVIANLAB LTD
        <br />
        Διεύθυνση: 1612 SOFIA BUL. TSAR BORIS III № 81 ET.1, AP.1
        <br />
        Email: info@vivianlab.com
        <br />
        VAT: BG207933919
      </p>

      <h2>19. ΣΗΜΑΝΤΙΚΗ ΕΙΔΟΠΟΙΗΣΗ: ΣΕΒΑΣΜΟΣ & ΕΚΤΙΜΗΣΗ</h2>
      <p>
        Η Πλατφόρμα διέπεται από τις αξίες του σεβασμού και της εκτίμησης. Όλοι οι Καταναλωτές
        πρέπει να τηρούν αυτές τις αρχές στις αλληλεπιδράσεις τους.
      </p>
      <p>
        Η κακή χρήση εργαλείων ΤΝ για δημιουργία προσβλητικού, επιβλαβούς ή διακριτικού περιεχομένου
        απαγορεύεται αυστηρά και μπορεί να οδηγήσει σε άμεση αναστολή λογαριασμού.
      </p>
      <p>Μηδενική ανοχή σε:</p>
      <ul>
        <li>Προσβλητική, προκλητική ή απειλητική γλώσσα</li>
        <li>
          Διακρίσεις λόγω φύλου, ταυτότητας φύλου, εθνικότητας, θρησκείας, αναπηρίας, σεξουαλικού
          προσανατολισμού ή ηλικίας
        </li>
        <li>Οποιαδήποτε μορφή παρενόχλησης</li>
      </ul>
      <p>Παραβάσεις μπορεί να οδηγήσουν σε απενεργοποίηση λογαριασμού ή/και νομική ενέργεια.</p>

      <h2>ΔΗΛΩΣΗ ΔΙΑΦΑΝΕΙΑΣ ΤΕΧΝΗΤΗΣ ΝΟΗΜΟΣΥΝΗΣ (AI TRANSPARENCY STATEMENT)</h2>
      <p>
        Η Πλατφόρμα περιλαμβάνει λειτουργίες που βασίζονται σε Τεχνητή Νοημοσύνη και δημιουργούν
        αυτοματοποιημένο περιεχόμενο, όπως προτάσεις ευεξίας, ερμηνείες συμπτωμάτων και
        εξατομικευμένες ενδείξεις.
      </p>
      <p>
        Χρησιμοποιώντας αυτές τις λειτουργίες, αναγνωρίζετε ότι επικοινωνείτε με σύστημα τεχνητής
        νοημοσύνης και όχι με άνθρωπο. Τα αποτελέσματα ΤΝ ενδέχεται να είναι ανακριβή ή ελλιπή και
        δεν πρέπει να χρησιμοποιούνται για ιατρική διάγνωση, θεραπεία ή επείγουσες αποφάσεις υγείας.
      </p>
      <p>
        Η χρήση λειτουργιών ΤΝ απαιτεί τη ρητή συγκατάθεσή σας. Μπορείτε να απενεργοποιήσετε τις
        λειτουργίες ΤΝ οποιαδήποτε στιγμή επικοινωνώντας με την Εταιρεία. Τα συστήματα AI που
        χρησιμοποιούνται στην Πλατφόρμα δεν προβαίνουν σε αυτοματοποιημένη λήψη αποφάσεων που παράγει
        έννομα ή παρομοίως σημαντικά αποτελέσματα για τους χρήστες.
      </p>
      <p>
        Οι χρήστες έχουν το δικαίωμα να ζητήσουν διευκρινίσεις σχετικά με τον τρόπο παραγωγής των
        αποτελεσμάτων της ΤΝ και τον τρόπο χρήσης των δεδομένων τους στην επεξεργασία ΤΝ, επικοινωνώντας
        με την Εταιρεία.
      </p>
      <p>ΟΙ ΠΑΡΟΝΤΕΣ ΟΡΟΙ ΧΡΗΣΗΣ ΓΙΑ ΚΑΤΑΝΑΛΩΤΕΣ ΤΡΟΠΟΠΟΙΗΘΗΚΑΝ ΤΕΛΕΥΤΑΙΑ ΣΤΙΣ 5/12/2025</p>
      <p>
        Με την επιλογή «Αποδέχομαι» ή με τη χρήση της Πλατφόρμας, δηλώνετε ότι έχετε διαβάσει,
        κατανοήσει και αποδέχεστε τους Όρους Χρήσης και την{' '}
        <ExternalLink href="/privacy-policy">Πολιτική Απορρήτου</ExternalLink> .
      </p>
    </div>
  );
}

export default ConsumerTermsGreek;
